module.exports = __webpack_public_path__ + "fd5a608a/img/50000000-5.7520d147.png";